import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

import { Upload } from '../uploads/upload';
import { UploadService } from '../uploads/upload.service';

@Component({
  selector: 'app-participantes',
  templateUrl: './participantes.component.html',
  styleUrls: ['./participantes.css'],
  providers: [UploadService]
})
export class ListaParticipantesComponent implements OnInit {
  public titulo: string = "Uploads";
  public uploads: Upload[];
  public params:any = {documento: undefined, identificador:undefined, criado_em_from:undefined, criado_em_to:undefined};
  public mask = [ /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public dataOptions = [{
    format: 'dd/mm/yyyy',
    monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mar', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    monthsFull: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    weekdaysFull: ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'],
    weekdaysShort: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'],
    today: 'Hoje',
    clear: 'Limpar',
    close: 'OK',
    closeOnSelect: true

  }];
  public busy: Promise<any>;
  public paginaAtual: number = 1;
  public itensPorPagina: number = 1;
  public totalItens: number = 1;


  constructor(
    private uploadService: UploadService,
    private _flashMessagesService: FlashMessagesService,
    private router: Router
  ) { }

  geUploads(): void {
    this.params['page'] = this.paginaAtual;

    console.log('params: ', this.params);
    this.busy = this.uploadService.getUploads(this.params)
      .then(uploads => this.carregar(uploads));
  }

  apagar(upload: Upload): void {
    if(confirm('Deseja realmente excluir esse upload dos participantes? Essa operação não pode ser revertida após a confirmação.')){
      this.busy = this.uploadService.deleteUpload(upload)
          .then(() => this.geUploads());
    }
  }

  carregar(uploads: any): void{
    this.uploads = uploads.data;
    this.paginaAtual = uploads.current_page;
    this.totalItens = uploads.total;
    this.itensPorPagina = uploads.per_page;
  }

  agendar(upload:Upload):void {
    this.busy = this.uploadService.agendar(upload);
  }

  confirmaEnvios(upload:Upload) {
    if(confirm("Você deseja realmente enviar os Certificados por e-mail para todos os participantes desta lista?")) {
        this.agendar(upload);
    }
  }

  goVerListaParticipantes(uploadId:number): void{
      this.router.navigate(['/ver-lista-participantes/' + uploadId]);
  }

  pageChanged(page: any): void{
    this.paginaAtual = page;
    this.geUploads();
  }

  ngOnInit() {
    this.geUploads();
  }

}



// WEBPACK FOOTER //
// ./src/app/lista-participantes/participantes.component.ts